<template>
  <div class="osm-map-page">
    <div class="map-container">
      <OsmMapView 
        :center="center" 
        :zoom="zoom"
        :myPosition="myPosition"
        :showMyPosition="showMyPosition"
        :circleRadius="circleRadius"
        :inKqArea="localInKqArea"
        :showCompanyMarker="true"
      />
    </div>
  </div>
</template>

<script>
import OsmMapView from './OsmMapView.vue'

export default {
  name: 'OsmMapPage',
  components: {
    OsmMapView
  },
  props: {
    lng: {
      type: Number,
      default: 116.404
    },
    lat: {
      type: Number,
      default: 39.915
    },
    zoom: {
      type: Number,
      default: 14
    },
    circleRadius: {
      type: Number,
      default: 500
    },
    myLng: {
      type: Number,
      default: 116.406
    },
    myLat: {
      type: Number,
      default: 39.917
    },
    inKqArea: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showMyPosition: true,
      localInKqArea: this.inKqArea // 创建本地数据属性存储inKqArea的值
    }
  },
  watch: {
    inKqArea(newVal) {
      this.localInKqArea = newVal // 监听props变化并更新本地数据
    }
  },
  computed: {
    center() {
      return [this.lng, this.lat]
    },
    myPosition() {
      return [this.myLng, this.myLat]
    }
  }
}
</script>

<style scoped>
.osm-map-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  margin: 0 !important;
  box-sizing: border-box;
}

h1 {
  margin-top: 0;
  color: #333;
  text-align: center;
  display: none; /* 隐藏标题以避免占用空间 */
}

.map-container {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none !important;
  border-radius: 0 !important;
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
}

.controls {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
}

.control-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

label {
  font-size: 16px;
  color: #555;
}

input[type="checkbox"] {
  width: 20px;
  height: 20px;
}
</style>